/**
 * Check if navigator is defined - safe for SSR
 * Always call this as a function: isNavigatorDefined()
 */
export const isNavigatorDefined = () => typeof navigator !== "undefined";
